import { CongSetting, CongSettings } from "../../../types/scheduling/settings";
import { useTranslation } from "react-i18next";
import { MaxSongNumber } from "../../../helpers/util";
import { CheckBox, DDMnumbers, DDMstrings, TextInput } from "./settings";

export const SettingsMM = (props: {
  settings: CongSettings;
  setSettings: (set: CongSettings) => void;
  showCOName: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div>
      {props.showCOName && (
        <TextInput
          settingKey={CongSetting.CircuitOverseerName}
          settings={props.settings}
          setSettings={props.setSettings}
        />
      )}
      <TextInput
        settingKey={CongSetting.CircuitOverseerMMTalkTitle}
        settings={props.settings}
        setSettings={props.setSettings}
      />
      <DDMnumbers
        settings={props.settings}
        setSettings={props.setSettings}
        settingKey={CongSetting.CircuitOverseerMMClosingSong}
        options={MaxSongNumber}
        allowZero
        zeroIsBlank
      />
      <DDMnumbers
        settings={props.settings}
        setSettings={props.setSettings}
        settingKey={CongSetting.SchoolSize}
        options={3}
      />
      <DDMstrings
        settings={props.settings}
        setSettings={props.setSettings}
        settingKey={CongSetting.MMPrintDate}
        options={[
          { label: t("general.week_of"), value: "weekof" },
          { label: t("general.day_of"), value: "dayof" },
        ]}
        labelSuffix={t("conganalysis.attendance.midweek")}
      />
      <CheckBox
        switchType
        settingKey={CongSetting.GenerateAssistantS89}
        settings={props.settings}
        setSettings={props.setSettings}
      />
    </div>
  );
};
